import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15ad2738&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ad2738')) {
      api.createRecord('15ad2738', component.options)
    } else {
      api.reload('15ad2738', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15ad2738&", function () {
      api.rerender('15ad2738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newPopover/index.vue"
export default component.exports